// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commonParagraph_medium[data-v-acca855a]{font-size:16px}.commonParagraph_large[data-v-acca855a]{font-size:18px}.commonParagraph_white[data-v-acca855a]{color:#fff}.commonParagraph_without-margin[data-v-acca855a]{margin:0}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
